import api from "services/api";

/**
 * Get all meetings with optional filters (filter: all/upcoming/past/today, search, my_meetings)
 */
export const getMeetings = async (params = {}) => {
  return api.get("/v1/api/meetings/list", { params });
};

/**
 * Get meeting detail by ID
 */
export const getMeetingDetail = async (id) => {
  return api.get(`/v1/api/meetings/detail/${id}`);
};

/**
 * Create a new meeting
 * @param {Object} meetingData { title, meeting_datetime, meeting_link, participant_ids, document: { title, content } }
 */
export const createMeeting = async (meetingData) => {
  return api.post("/v1/api/meetings/create", meetingData);
};

/**
 * Update a meeting
 */
export const updateMeeting = async (id, meetingData) => {
  return api.put(`/v1/api/meetings/update/${id}`, meetingData);
};

/**
 * Delete a meeting
 */
export const deleteMeeting = async (id) => {
  return api.delete(`/v1/api/meetings/delete/${id}`);
};

/**
 * Add participants to a meeting
 */
export const addMeetingParticipants = async (id, participantIds) => {
  return api.post(`/v1/api/meetings/${id}/participants/add`, {
    participant_ids: participantIds,
  });
};

/**
 * Remove a participant from a meeting
 */
export const removeMeetingParticipant = async (id, employeeId) => {
  return api.delete(`/v1/api/meetings/${id}/participants/${employeeId}`);
};

/**
 * Save or update a meeting document (stores HTML content)
 * @param {Object} documentData { meeting_id, document_id, title, content }
 */
export const saveMeetingDocument = async (documentData) => {
  return api.post("/v1/api/meetings/documents/save", documentData);
};

/**
 * Get document details by ID
 */
export const getMeetingDocument = async (id) => {
  return api.get(`/v1/api/meetings/documents/${id}`);
};

/**
 * Delete a meeting document
 */
export const deleteMeetingDocument = async (id, meetingId) => {
  return api.delete(`/v1/api/meetings/documents/${id}`, {
    params: { meeting_id: meetingId },
  });
};

